<template lang="pug">
    div.progress-bar
        div.progress-bar__inner( :style="{ 'width': value + '%', 'background-color': color }")
</template>

<script>
    export default {
        name: "ProgressBar",
        props: {
            color: String,
            value: Number
        },
        data() {
            return {
                
            }
        }
    }
</script>

<style scoped lang="scss">
    .progress-bar {
        width: 100%; 
        height: 8px; 
        background-color: #aaaaaa;

        &__inner {
            height: 100%; 
        }
    }
</style>